const ko = {
  lang: 'ko',
  langName: '한국어',
  flag: '🇰🇷',

  // Meta / SEO
  siteTitle: 'Power TOEFL — 2026 토플 연습 · 모의고사 · 가이드',
  siteDescription: '2026 iBT 형식 독립 연습 플랫폼. 섹션 연습·모의고사 센터·형식 가이드. 토플 무료 모의고사는 전용 페이지에서 가입 없이. ETS 비제휴. 성적은 1–6점 밴드.',
  ogTitle: '토플 무료 모의고사 — 2026 형식, 가입 없이 | Power TOEFL',

  // Header
  navGrammar: '문법',
  navPractice: '파트별 연습',
  navScoreChart: '점수 변환표',
  navVocabulary: '단어장',
  navTips: '팁/전략',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'Speaking',
  navWriting: 'Writing',
  navQuestionPool: '문제은행',
  navResources: '학습자료',

  // Auth
  loginButton: '로그인',
  wrongAnswers: '오답노트',
  logout: '로그아웃',
  loginRequired: '오답노트 & 이어풀기 기능은 로그인이 필요합니다.',
  googleLogin: '구글로 시작하고 프리미엄 기능 활성화',

  // Hero
  heroBadge: '2026 형식 · 가입 없이 바로 시작',
  heroTitle1: 'TOEFL 고득점을 위한',
  heroTitle2: '단 하나의 플랫폼',
  heroDesc1: '토플 무료 모의고사. 리딩 50문항 30분, 리스닝 47문항 29분, 스피킹 Listen and Repeat, 라이팅 이메일.',
  heroDesc2: 'ETS 비제휴. 연습 성적은 1–6점. 가입 없이 시작하세요.',

  // Sections
  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47문항',
  lcTime: '29분',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50문항',
  rcTime: '30분',
  startTest: '시험 시작',
  fullTestStart: '전체 모의고사 시작 (Reading → Listening)',
  fullTestDesc: '두 섹션을 순서대로 풀어보세요',

  // Parts
  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  // Quick Links
  moreTools: '더 많은 학습 도구',
  practiceLabel: '섹션별 연습',
  practiceDesc: 'Reading·Listening 개별 학습',
  scoreChartLabel: '점수 변환표',
  scoreChartDesc: '정답 수 → 환산 점수',
  vocabLabel: '단어장',
  vocabDesc: '토플 필수 어휘',
  tipsLabel: '팁/전략',
  tipsDesc: 'Listening·Reading 공략법',
  catLabel: 'CAT 테스트',
  catDesc: '실력에 맞게 난이도 자동 조절',
  fullTestCardLabel: 'Full Test 모의고사',
  fullTestCardDesc: 'Reading + Listening 실전 모의',

  // Stats
  statQuestions: '문항',
  statParts: '파트',
  statMinutes: '분',

  // Footer
  footerMockTest: '연습',
  footerQuestionPool: '문제은행',
  footerPractice: '섹션별 연습',
  footerStudy: '학습',
  footerBooks: '추천 교재',
  footerEtc: '기타',
  footerLC: 'Listening 연습',
  footerRC: 'Reading 연습',
  footerSpeaking: 'Speaking 연습',
  footerWriting: 'Writing 연습',
  footerLCStrategy: 'Listening 전략',
  footerRCStrategy: 'Reading 전략',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL®은 ETS의 등록 상표입니다. Power TOEFL은 ETS와 제휴하거나 공인된 사이트가 아니며, 독자적으로 운영되는 토플 학습 플랫폼입니다.',

  // FAQ
  faqTitle: '❓ 자주 묻는 질문 (FAQ)',
  faqDesc: '토플 시험과 Power TOEFL에 대해 궁금한 점을 확인하세요.',
  faqPageTitle: 'TOEFL 시험 접수·점수 계산·유효기간 — 2026 FAQ 총정리 | Power TOEFL',
  faqPageDesc: 'TOEFL 접수 방법, 점수 환산, 유효기간, 섹션별 전략까지 — 학습자가 가장 많이 묻는 질문을 한 페이지에서 확인하세요.',
  faqMore: '더 궁금한 점이 있으신가요? 지속적으로 FAQ를 업데이트하고 있습니다.',

  // Score Chart
  scoreChartPageTitle: 'TOEFL 점수 환산표 2026 — 섹션별 점수 즉시 확인 | Power TOEFL',
  scoreChartPageDesc: 'TOEFL 섹션별(Reading·Listening·Speaking·Writing) 점수 환산표. 정답 수 입력으로 예상 점수 + 목표 점수별 학습 가이드.',
  scoreChartHeading: '📊 TOEFL 점수 환산표',
  scoreChartIntro: '아래 0~30 영역별·0~120 총점 표는 비교 가능한 기존 척도를 활용한 Power TOEFL 학습용 추정치입니다. 2026년 공식 성적표는 영역별·종합 1~6점(0.5점 단위)을 우선 표시합니다.',
  scoreChartLC: 'Reading 환산표',
  scoreChartRC: 'Listening 환산표',
  scoreChartCorrect: '정답 수',
  scoreChartConverted: '환산 점수',
  scoreChartUnit: '개',
  scoreChartPointUnit: '점',
  scoreGuideTitle: '🎯 목표 점수별 가이드',
  scoreGuide900: '최상위',
  scoreGuide900Desc: '각 섹션 28+ 필요. 상위권 대학 입학 가능 수준.',
  scoreGuide800: '상위',
  scoreGuide800Desc: '각 섹션 22+ 목표. 대부분의 대학 입학 기준 충족.',
  scoreGuide700: '중상위',
  scoreGuide700Desc: '기본적 학술 영어 수준. 조건부 입학 가능.',
  scoreGuide600: '중급',
  scoreGuide600Desc: '기초 단계. Reading과 Listening 집중 학습 추천.',
  scoreChartFaqTitle: '❓ TOEFL 점수 자주 묻는 질문',
  scoreChartCtaTitle: '지금 바로 실력을 확인해보세요',
  scoreChartCtaDesc: '무료 TOEFL 모의고사로 나의 예상 점수를 알아보세요.',

  // Vocabulary
  vocabPageTitle: '토플 빈출 단어 600개 — 카테고리별 뜻·예문 즉시 암기 | Power TOEFL',
  vocabPageDesc: '비즈니스·인사·마케팅·금융·제조·일상 6개 카테고리 600단어. 클릭하면 뜻과 예문이 바로 나오는 토플 단어장으로 효율적으로 암기하세요.',
  vocabHeading: '📚 토플 필수 단어장',
  vocabIntro: '카테고리별 필수 단어를 학습하세요. 클릭하면 뜻이 보입니다.',
  vocabShowAll: '전체 보기',
  vocabHideAll: '전체 숨기기',
  vocabReset: '초기화',
  vocabClickToReveal: '클릭하여 뜻 보기',
  vocabMotivation: '꾸준히 반복 학습하면 토플 점수가 올라갑니다! 🚀',
  vocabCatNaturalScience: '자연과학',
  vocabCatSocialScience: '사회과학',
  vocabCatHumanities: '인문학',
  vocabCatLifeScience: '생명과학',
  vocabCatTechnology: '기술/공학',
  vocabCatAcademicGeneral: '학술 일반',
  vocabSynonyms: '동의어',
  vocabAntonyms: '반의어',
  vocabMyWords: '나만의 단어장',
  vocabAddWord: '단어 추가',
  vocabAddWordPlaceholder: '영어 단어를 입력하세요',
  vocabMyWordsEmpty: '아직 추가한 단어가 없습니다. 위에서 단어를 입력해 보세요!',
  vocabDeleteWord: '삭제',
  vocabLookingUp: '검색 중...',
  vocabFlashcardStart: '플래시카드 암기 시작',
  vocabFlashcardStop: '플래시카드 정지',
  vocabFlashcardEmpty: '플래시카드를 시작하려면 단어를 먼저 추가하세요.',
  vocabFlashcardSpeed: '속도',
  vocabFlashcardSpeedSlow: '느리게',
  vocabFlashcardSpeedNormal: '보통',
  vocabFlashcardSpeedFast: '빠르게',
  vocabFlashcardShuffle: '섞기',
  vocabFlashcardPrev: '이전',
  vocabFlashcardNext: '다음',
  vocabFlashcardFlip: '뒤집기',
  vocabFlashcardProgress: '{current} / {total}',
  vocabQuizTitle: '단어 퀴즈',
  vocabQuizDesc: '학습한 단어의 동의어·반의어를 맞춰보세요!',
  vocabQuizMode_synonym: '동의어 퀴즈',
  vocabQuizMode_antonym: '반의어 퀴즈',
  vocabQuizMode_mixed: '혼합 퀴즈',
  vocabQuizClose: '닫기',
  vocabQuizNoQuestions: '이 카테고리에 퀴즈 문제가 부족합니다.',
  vocabQuizBack: '돌아가기',
  vocabQuizResult: '퀴즈 결과',
  vocabQuizExcellent: '훌륭합니다! 🎉',
  vocabQuizGood: '잘했어요! 조금만 더 연습하면 완벽!',
  vocabQuizKeepGoing: '계속 학습해 보세요! 💪',
  vocabQuizRetry: '다시 풀기',
  vocabQuizFindSynonym: '다음 단어의 동의어를 고르세요',
  vocabQuizFindAntonym: '다음 단어의 반의어를 고르세요',
  vocabQuizNext: '다음',
  vocabQuizFinish: '결과 보기',
  vocabQuizStart: '퀴즈 시작',

  // Tips
  tipsLCPageTitle: '토플 리스닝 점수 올리는 법 | LC 실전 훈련 루틴 — Power TOEFL',
  tipsLCPageDesc: '토플 LC 리스닝 점수 올리는 실전 훈련법. Conversations·Lectures 노트 테이킹, 추론, 태도 파악 문제까지 완벽 대비.',
  tipsLCHeading: '🎧 토플 리스닝 점수 올리는 법',
  tipsLCIntro: '토플 LC 파트별 핵심 공략법과 실전 훈련 루틴을 정리했습니다.',
  tipsLCButton: 'LC 전략',
  tipsRCButton: 'RC 전략',
  tipsLCPractice: 'LC 실전 연습하기',
  tipsLCPracticeDesc: '전략을 익혔다면 실전 모의고사로 연습해보세요.',
  tipsLCStartTest: 'LC 모의고사 시작',
  tipsRCPageTitle: 'TOEFL Reading 공략법 — 학술 지문 전략 | Power TOEFL',
  tipsRCPageDesc: 'TOEFL Reading 섹션의 학술 지문 독해 전략, 시간 배분, 요약 문제 공략법.',
  tipsRCHeading: '📖 TOEFL Reading 공략법',
  tipsRCIntro: 'TOEFL Reading의 학술 지문 독해 전략과 시간 배분법을 정리했습니다.',
  tipsRCPractice: 'RC 실전 연습하기',
  tipsRCPracticeDesc: '전략을 익혔다면 실전 모의고사로 연습해보세요.',
  tipsRCStartTest: 'RC 모의고사 시작',

  // Practice page — per-part unique SEO meta
  practicePartMeta: {
    '1': { title: 'TOEFL Reading 학술 지문 공략법 — 20문항 완벽 전략 | Power TOEFL', desc: 'TOEFL Reading 학술 지문을 효과적으로 읽는 법. 키워드 스캐닝, 추론 문제, 요약 문제 공략까지 한번에 정리합니다.' },
    '2': { title: 'TOEFL Listening 캠퍼스 대화 공략 — 10문항 노트 테이킹 전략 | Power TOEFL', desc: 'TOEFL Listening Conversations 핵심 전략. 교수-학생 대화의 목적 파악, 태도 추론, 노트 테이킹 기법을 알려드립니다.' },
    '3': { title: 'TOEFL Listening 강의 공략법 — 18문항 핵심 전략 | Power TOEFL', desc: 'TOEFL Listening Lectures 공략법. 강의 주제 파악, 교수 의도 추론, 예시 목적 분석으로 고득점을 달성하세요.' },
  } as Record<string, { title: string; desc: string }>,

  // Practice page — per-part rich body content
  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading 섹션은 학술 지문(약 700단어)을 읽고 주제, 세부 정보, 추론, 어휘, 요약 문제에 답하는 유형입니다. 35분 동안 2개 지문, 총 20문항을 풀어야 하며, 각 문단의 주제문 파악과 키워드 스캐닝이 시간 관리의 핵심입니다.',
      commonTypes: ['주제/목적 파악 (What is the passage mainly about?)', '세부 정보 (According to the passage...)', '어휘 문제 (The word X is closest in meaning to...)', '추론 문제 (What can be inferred?)', '문장 삽입 (Insert text)', '요약 문제 (Prose Summary — 핵심 3개 선택)'],
      strategy: ['질문을 먼저 읽고 키워드 2~3개를 기억한 뒤 지문을 스캐닝', '각 문단의 첫 문장(주제문)에 집중 — TOEFL 학술 지문은 대부분 두괄식', '어휘 문제는 사전적 의미가 아닌 문맥 속 의미로 판단', '요약 문제는 세부 사항이 아닌 핵심 아이디어 3개만 선택'],
      recommendedFor: ['TOEFL 입문자 — 학술 지문 독해 감각 잡기', 'Reading 20점 이상 목표 — 시간 배분 전략 필수', '추론·요약 문제에 약한 학습자 — 유형별 집중 훈련'],
      faq: [
        { q: 'TOEFL Reading에서 시간이 부족할 때는?', a: '지문당 17~18분을 배분하고, 어려운 문제는 표시 후 넘기세요. 요약 문제에 최소 3분을 남겨두는 것이 핵심입니다.' },
        { q: '어휘 문제에서 모르는 단어가 나오면?', a: '문맥에서 의미를 추론하세요. 빈칸 앞뒤 문장의 힌트가 정답 단서입니다. 사전적 의미와 다를 수 있습니다.' },
        { q: '요약 문제(Prose Summary)는 어떻게 풀어야 하나요?', a: '세부 사항이 아닌 각 문단의 핵심 아이디어를 대표하는 3개 선택지를 고르세요. 한 문단에만 해당하는 세부 정보는 오답입니다.' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversations는 캠퍼스 내 대화(교수-학생, 직원-학생)를 듣고 질문에 답하는 유형입니다. 약 3~5분 길이의 대화를 듣고 5개 문제를 풀며, 대화의 목적, 세부 정보, 화자의 태도를 파악하는 것이 핵심입니다.',
      commonTypes: ['대화 목적 (Why does the student visit the professor?)', '세부 정보 (What does the professor say about...?)', '화자 태도/의도 (What is the student\'s attitude?)', '다음 행동 (What will the student probably do next?)'],
      strategy: ['대화 시작 부분에서 방문 목적을 즉시 파악', '노트 테이킹으로 핵심 정보(이름, 날짜, 조건)를 기록', '화자의 어조와 감정 표현에 주의 — 태도 문제의 핵심 단서', '대화 마지막 부분의 결론이나 다음 행동에 집중'],
      recommendedFor: ['TOEFL Listening 15점 이하 — 짧은 대화부터 감각 잡기', 'Lectures보다 쉬운 유형부터 시작하고 싶은 학습자', '노트 테이킹 연습이 필요한 학습자'],
      faq: [
        { q: 'Conversations에서 노트 테이킹은 필수인가요?', a: '네, TOEFL은 문제를 대화 후에 보여주므로 기억에만 의존하면 세부 정보를 놓칩니다. 약어와 기호를 활용한 빠른 메모가 핵심입니다.' },
        { q: '화자의 태도를 어떻게 파악하나요?', a: '어조(확신/불확실), 감정 표현("I\'m not sure about that", "That sounds great"), 반복 강조 등이 태도 문제의 핵심 단서입니다.' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lectures는 대학 강의(약 5~7분)를 듣고 6개 문제에 답하는 유형입니다. 생물학, 역사, 예술, 지질학 등 다양한 학술 주제가 출제되며, 강의 주제 파악, 교수 의도 추론, 예시 목적 분석이 핵심입니다.',
      commonTypes: ['강의 주제 (What is the lecture mainly about?)', '교수 의도 (Why does the professor mention X?)', '세부 정보 (According to the professor...)', '추론 (What does the professor imply?)', '강의 구조 (How does the professor organize the lecture?)'],
      strategy: ['강의 처음 1~2분에서 주제와 목적을 파악 — 가장 기본적인 문제 유형', '교수가 예시를 드는 이유를 항상 생각 — "Why does the professor mention X?"의 핵심', '전환 표현(Now, let\'s move on to...)에서 새로운 하위 주제 시작', '교수의 반어적 표현, 유머, 수사적 질문의 의미를 추론'],
      recommendedFor: ['TOEFL Listening 20점 이상 목표 — Lectures가 점수의 핵심', '학술 강의 청취에 어려움을 느끼는 학습자', '노트 테이킹 체계를 잡고 싶은 학습자'],
      faq: [
        { q: '"Why does the professor mention X?" 유형은 어떻게 풀어야 하나요?', a: '교수가 예시·비유·실험을 언급하는 이유는 보통 앞서 설명한 개념을 보충하거나 대조하기 위해서입니다. 언급 직전 문맥에서 목적을 찾으세요.' },
        { q: 'Lectures에서 배경 지식이 없으면 불리한가요?', a: '아닙니다. TOEFL은 강의 내에서 필요한 정보를 모두 제공합니다. 배경 지식은 도움이 되지만, 강의 내용만으로 모든 문제를 풀 수 있도록 설계되어 있습니다.' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  // Practice page — internal link labels
  practiceRelatedLinks: '📌 관련 학습 콘텐츠',
  practiceOtherParts: '다른 파트 공략',
  practiceMockTestCTA: '실전 모의고사로 연습하기',
  practiceTipsLink: '파트별 전략 보기',
  practiceGrammarLink: '문법 학습하기',

  practiceNotFound: '파트를 찾을 수 없습니다.',
  practiceQuestionType: '문제 유형',
  practiceTips: '💡 공략 팁',
  practiceExamples: '📝 예시 문제',
  practiceIntro: '📋 파트 소개',
  practiceCommonTypes: '📊 자주 나오는 유형',
  practiceStrategy: '🎯 공략 포인트',
  practiceRecommendedFor: '👤 이런 학습자에게 추천',
  practiceFAQ: '❓ 자주 묻는 질문',
  practiceCTA: '지금 바로 연습해보세요',
  practiceCTADesc: '실전과 동일한 환경에서 Part {0}를 풀어볼 수 있습니다.',
  practiceStartTest: '{0} 모의고사 시작',
  practiceQuestions: '문항',
  practicePartSelect: '파트 선택',

  // Rounds
  roundsTitle: '모의고사 회차',
  roundLabel: 'TOEFL 모의고사',
  roundUnit: '회',
  comingSoon: '준비 중',

  // Test page
  testPrevious: '이전',
  testNext: '다음',
  testQuestion: '문제',
  testQuestionPrompt: '다음 문제를 보고 알맞은 답 고르시오.',
  testMarkAnswer: '알맞은 정답 번호를 마킹해주세요.',
  testSelect: '선택하기',
  testShowAnswer: '정답 및 해설 보기',
  testCorrect: '정답입니다!',
  testIncorrect: '오답입니다.',
  testLoginPrompt: '오답노트 & 이어풀기 기능은 로그인이 필요합니다.',
  testGoogleLogin: '구글로 3초 만에 시작하기',
  roundSelect: '다른 회차 선택',
  testAnswered: '답변 완료',
  testSubmit: '시험 제출',
  testSubmitTitle: '{0} 시험을 제출하시겠습니까?',
  testSubmitDesc: '{0}개 중 {1}개 문항에 답변했습니다.',
  testUnanswered: '{0}개 문항이 미답변입니다.',
  testCannotUndo: '이 작업은 취소할 수 없습니다.',
  testContinue: '계속 풀기',
  testSubmitBtn: '제출',

  // Results page
  resultsTitle: '{0} 시험 결과',
  resultsTimeUsed: '소요 시간: {0}분 {1}초',
  resultsEstimatedScore: '예상 점수 (30점 만점)',
  resultsCorrect: '정답',
  resultsIncorrect: '오답',
  resultsAccuracy: '정답률',
  resultsReview: '답안 검토',
  resultsYourAnswer: '내 답변: {0}',
  resultsCorrectAnswer: '정답: {0}',
  resultsNoAnswer: '미답변',
  resultsHome: '홈',
  resultsWrongNotes: '오답노트',
  resultsRetry: '다시 풀기',
  resultsShare: '결과 공유',
  resultsShareText: '나의 TOEFL {0} 예상 점수는 {1}점! ({2}/{3} 정답, 정답률 {4}%) Power TOEFL에서 무료로 실력을 테스트해보세요!',
  resultsShareCopied: '결과가 클립보드에 복사되었습니다!',
  resultsNoResults: '시험 결과가 없습니다.',
  resultsGoHome: '홈으로',
  resultsSaved: '오답 {0}개가 오답노트에 저장되었습니다',

  // Wrong answers page
  wrongAnswersTitle: '오답노트',
  wrongAnswersSaved: '저장된 문항',
  wrongAnswersHome: '홈',
  wrongAnswersPracticeAll: '전체 연습',
  wrongAnswersAll: '전체',
  wrongAnswersNoItems: '아직 오답이 없습니다. 먼저 시험을 보세요!',
  wrongAnswersYourAnswer: '내 답변: {0}',
  wrongAnswersCorrectIs: '정답: {0}',
  wrongAnswersReviewed: '복습 완료',
  wrongAnswersRemoved: '오답노트에서 삭제됨',
  wrongAnswersPracticeMode: '연습 모드',
  wrongAnswersCorrectMsg: '정답입니다!',
  wrongAnswersIncorrectMsg: '오답입니다. 정답: {0}',
  wrongAnswersNextQuestion: '다음 문제',
  wrongAnswersFinish: '연습 끝내기',
  wrongAnswersExitPractice: '연습 나가기',
  wrongAnswersPracticeComplete: '연습 완료!',
  wrongAnswersNoPractice: '연습할 오답이 없습니다',
  wrongAnswersLimitNotice: '최근 500개 오답만 표시됩니다.',

  // Privacy Policy
  privacyPageTitle: '개인정보처리방침 — Power TOEFL',
  privacyPageDesc: 'Power TOEFL의 개인정보처리방침입니다.',
  privacyHeading: '개인정보처리방침',
  privacyLastUpdated: '최종 업데이트: 2026년 3월 29일',
  privacyS1Title: '1. 수집하는 개인정보',
  privacyS1Body: 'Power TOEFL은 서비스 제공을 위해 Google 로그인 시 이메일 주소, 이름, 프로필 사진을 수집합니다. 유료 결제 시 결제 서비스(Dodo Payments/PayPal)를 통해 결제 정보가 처리되며, 당사는 결제 카드 정보를 직접 저장하지 않습니다.',
  privacyS2Title: '2. 개인정보 이용 목적',
  privacyS2Body: '수집한 개인정보는 오답노트 저장, 학습 진도 관리, 구독 관리, 고객 지원, 서비스 개선 등의 목적으로만 사용됩니다.',
  privacyS3Title: '3. 개인정보의 보관 및 파기',
  privacyS3Body: '회원 탈퇴 시 개인정보는 즉시 파기됩니다. 다만, 결제 기록은 관련 세법에 따라 최대 5년간 보관 후 파기합니다. 기타 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관 후 파기합니다.',
  privacyS4Title: '4. 개인정보의 제3자 제공',
  privacyS4Body: '본 서비스는 결제 처리를 위해 Dodo Payments(Merchant of Record) 또는 PayPal에 필요한 최소한의 정보(이메일)를 전달합니다. 그 외 이용자의 개인정보를 제3자에게 제공하지 않습니다. 법률에 의한 요청이 있는 경우 예외로 합니다.',
  privacyS5Title: '5. 쿠키 및 광고',
  privacyS5Body: '본 사이트는 Google AdSense를 통해 광고를 게재합니다. Google을 포함한 제3자 광고 사업자는 쿠키를 사용하여 이용자의 이전 방문 기록을 바탕으로 맞춤형(개인화) 광고를 게재할 수 있습니다. Google의 광고 쿠키 사용으로 이용자는 본 사이트 및 인터넷상의 다른 사이트 방문 기록에 기반한 광고를 보게 됩니다. 이용자는 Google 광고 설정(google.com/settings/ads)에서 개인 맞춤 광고를 비활성화하거나, www.aboutads.info 에서 제3자 사업자의 쿠키 사용을 거부할 수 있습니다. 쿠키는 브라우저 설정에서도 관리할 수 있습니다. 자세한 내용은 Google 개인정보 보호정책을 참조하세요.',
  privacyS6Title: '6. 국제 데이터 전송',
  privacyS6Body: '본 서비스는 해외 서버를 사용하며, 결제 처리를 위해 데이터가 국제적으로 전송될 수 있습니다. 적절한 보안 조치를 통해 개인정보를 보호합니다.',
  privacyS7Title: '7. 이용자의 권리',
  privacyS7Body: '이용자는 언제든지 자신의 개인정보에 대해 열람, 수정, 삭제를 요청할 수 있습니다. EU/EEA 거주자는 GDPR에 따른 추가적인 권리가 보장됩니다. 계정 삭제를 원하시면 로그아웃 후 문의해 주세요.',
  privacyS8Title: '8. 문의처',
  privacyS8Body: '개인정보 관련 문의사항은 skdaks0731@gmail.com으로 연락해 주세요.',

  // Terms of Service
  termsPageTitle: '이용약관 — Power TOEFL',
  termsPageDesc: 'Power TOEFL 서비스 이용약관입니다.',
  termsHeading: '이용약관',
  termsLastUpdated: '최종 업데이트: 2026년 7월 15일',
  termsS1Title: '1. 서비스 개요',
  termsS1Body: 'Power TOEFL은 TOEFL 시험 준비를 위한 온라인 학습 플랫폼입니다. 본 서비스의 등록된 법적 사업자명(legal business name)은 \'ddookddak\'입니다. 무료 기능과 유료 프리미엄(Pro/Lifetime) 구독을 통해 모의고사, 파트별 연습, AI 문제 생성, 오답노트 등의 기능을 제공합니다.',
  termsS2Title: '2. 이용 조건',
  termsS2Body: '본 서비스는 만 14세 이상 누구나 이용할 수 있습니다. 일부 기능(오답노트, AI 연습 등)은 Google 계정 로그인이 필요하며, 프리미엄 기능은 유료 구독이 필요합니다.',
  termsS3Title: '3. 지적 재산권',
  termsS3Body: '본 사이트의 콘텐츠(문제, 디자인, 코드 등)는 Power TOEFL에 귀속됩니다. TOEFL은 ETS의 등록 상표이며, 본 사이트는 ETS와 무관합니다.',
  termsS4Title: '4. 유료 서비스 및 결제',
  termsS4Body: '프리미엄 구독은 제3자 결제 서비스(Dodo Payments/PayPal)를 통해 처리됩니다. 구독 요금은 선택한 플랜(월간/연간/라이프타임)에 따라 자동 또는 일회성으로 청구됩니다. 모든 가격은 부가세(VAT)가 포함될 수 있으며, 결제 시점에 최종 금액이 표시됩니다. 환불 정책은 별도의 환불 규정 페이지를 참조하세요.',
  termsS5Title: '5. 면책 조항',
  termsS5Body: '본 서비스에서 제공하는 모의고사 점수 및 학습 자료는 참고용이며, 실제 TOEFL 시험 결과를 보장하지 않습니다. 서비스 이용으로 인한 직·간접적 손해에 대해 책임지지 않습니다.',
  termsS6Title: '6. 금지 행위',
  termsS6Body: '서비스를 이용하여 문제를 무단 복제·배포하거나, 시스템에 과도한 부하를 주는 행위, 계정을 타인과 공유하는 행위, 기타 불법적인 행위를 금지합니다.',
  termsS7Title: '7. 서비스 변경 및 중단',
  termsS7Body: '운영자는 서비스를 사전 고지 없이 변경하거나 중단할 수 있으며, 이에 대한 별도의 보상을 제공하지 않습니다.',
  termsS8Title: '8. 구독 해지',
  termsS8Body: '유료 구독은 언제든지 해지할 수 있습니다. 해지 시 남은 결제 기간까지는 프리미엄 기능을 계속 이용할 수 있으며, 이후 무료 플랜으로 자동 전환됩니다.',
  termsS9Title: '9. 약관 변경',
  termsS9Body: '본 약관은 필요에 따라 변경될 수 있으며, 변경 시 사이트에 공지합니다. 변경 후에도 서비스를 이용하면 변경된 약관에 동의한 것으로 간주합니다.',

  // Refund Policy
  refundPageTitle: '환불 및 해지 정책 — Power TOEFL',
  refundPageDesc: 'Power TOEFL 환불 및 구독 해지 정책입니다.',
  refundHeading: '환불 및 해지 정책',
  refundLastUpdated: '최종 수정일: 2026년 7월 15일',
  refundS1Title: '1. 환불 원칙',
  refundS1Body: '본 서비스는 디지털 상품 특성상 원칙적으로 환불이 불가합니다.',
  refundS2Title: '2. 예외적 환불',
  refundS2Body: '다만, 관련 법령에서 요구하는 경우 또는 중복 결제·서비스 미제공·중대한 기술적 장애가 확인되는 경우에는 환불이 제공될 수 있습니다.',
  refundS3Title: '3. 문의 방법',
  refundS3Body: '문의사항은 고객 지원/의견 남기기 게시판을 활용해주세요. 연락처: skdaks0731@gmail.com',
  refundS4Title: '4. 구독 해지',
  refundS4Body: '유료 구독은 언제든지 해지할 수 있습니다. 해지 후에도 현재 결제 기간이 끝날 때까지 이용하실 수 있으며, 이후 추가 청구는 발생하지 않습니다.',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  // Footer legal links
  footerPrivacy: '개인정보처리방침',
  footerTerms: '이용약관',
  footerRefund: '환불 규정',
  footerAbout: '사이트 소개',
  footerGuide: '학습 가이드',
  guideLabel: '학습 가이드',
  guideDesc: '스킬별 공략, 점수대별 전략, 시험 비교 정보',

  // About
  aboutPageTitle: '무료 토플 모의고사 + AI 약점 분석 — Power TOEFL 소개',
  aboutPageDesc: '2026 TOEFL iBT 형식 연습, AI 약점 분석, 오답 자동 복습. Power TOEFL이 어떤 플랫폼인지 확인하세요.',
  aboutHeading: 'Power TOEFL — 토플 실전 모의고사 학습 플랫폼',
  aboutS1Title: 'Power TOEFL이란?',
  aboutS1Body: 'Power TOEFL은 TOEFL iBT를 준비하는 학습자를 위한 온라인 연습 플랫폼입니다. 2026년 개정 형식의 영역별 연습, AI 피드백, 오답노트를 제공합니다. ETS 공식 문항이 아닌 자체 제작 학습 콘텐츠입니다.',
  aboutS2Title: '누가 쓰면 좋은가요?',
  aboutS2Body: '토플을 처음 준비하는 대학생, 취업을 위해 목표 점수가 필요한 직장인, 해외 취업이나 이직을 준비하는 분, 그리고 독학으로 토플을 공부하는 모든 분께 추천합니다.',
  aboutS3Title: '주요 기능',
  aboutFeature1: '2026 형식 Reading·Listening·Speaking·Writing 모의고사',
  aboutFeature2: 'Reading·Listening·Speaking·Writing 섹션별 집중 연습',
  aboutFeature3: 'AI 기반 난이도별 맞춤 문제 생성 & 약점 분석',
  aboutFeature4: '틀린 문제 자동 저장 오답노트 + 에빙하우스 복습',
  aboutFeature5: '점수 변환표 및 토플 필수 단어장',
  aboutS4Title: '무료와 프리미엄의 차이',
  aboutS4Body: '무료로 모의고사, 파트별 연습, 점수 변환표를 이용할 수 있습니다. 프리미엄(Pro)에서는 AI 무제한 문제 생성, 광고 제거, 전 회차 모의고사 이용이 가능합니다.',
  aboutS5Title: '왜 실력이 오르나요?',
  aboutS5Body: '에빙하우스 망각곡선 기반 복습과 영역별 약점 분석으로 반복 학습을 돕습니다. 점수 상승폭은 시작 수준·학습량·시험 컨디션에 따라 다르며, 특정 점수 상승을 보장하지 않습니다.',
  aboutS6Title: 'ETS와의 관계',
  aboutS6Body: 'Power TOEFL은 ETS와 제휴하거나 공인된 사이트가 아닙니다. TOEFL®은 ETS의 등록 상표이며, 본 사이트는 독자적으로 운영되는 학습 플랫폼입니다.',
  aboutS7Title: '문의하기',
  aboutS7Body: '서비스 관련 문의사항은 skdaks0731@gmail.com으로 연락해 주세요.',
  aboutCtaHeading: '지금 바로 시작하세요',
  aboutCtaDesc: '무료로 실전 모의고사를 풀어보세요.',
  aboutCtaStart: '모의고사 시작',
  aboutCtaPricing: '프리미엄 요금제 보기',

  // Resume / Progress
  resumeTest: '이어풀기',
  resumeDesc: '{0} {1}회 — {2}/{3}문항',
  progressLabel: '진행률',
  timerLabel: '남은 시간',
  timeUp: '시간이 종료되었습니다!',

  // Mobile nav
  navHome: '홈',
  navSettings: '팁/전략',

  // Grammar Book section
  grammarSectionTitle: '영문법 Book',
  grammarSectionDesc: 'TOEFL 필수 문법을 체계적으로 학습하세요',
  grammarViewAll: '전체 보기',
  grammarChapter: '챕터',

  // AI Practice
  aiPracticeTitle: 'AI 토플 문제 무한 생성 — 파트·난이도 선택하면 즉시 출제 | Power TOEFL',
  aiPracticeDesc: '원하는 파트와 난이도를 고르면 AI가 토플 문제를 즉시 생성. 해설까지 자동 제공되는 무료 연습문제로 매일 새로운 문제를 풀어보세요.',
  aiPracticeH1: '✨ AI 토플 문제 생성',
  aiPracticeSub: 'AI가 난이도에 맞는 토플 문제를 실시간으로 생성합니다.',
  aiPartLabel: '파트',
  aiDiffLabel: '난이도',
  aiBeginner: '초급 (1.0–2.5)',
  aiIntermediate: '중급 (3.0–4.5)',
  aiAdvanced: '고급 (5.0–6.0)',
  aiGenerate: '문제 생성',
  aiGenerating: '생성 중...',
  aiRemainingToday: '이번 달 {0}회 남음',
  aiLimitReached: '이번 달 AI 크레딧을 모두 사용했습니다',
  aiLimitUpgrade: '추가 크레딧을 구매하거나 플랜을 업그레이드하세요!',
  aiUpgrade: '업그레이드',
  aiListenPrompt: '🔊 LC 문제는 음성을 들으며 풀어보세요',
  aiPlayAudio: '음성 재생',
  aiStopAudio: '중지',
  aiCorrect: '✅ 정답입니다!',
  aiWrong: '❌ 오답입니다.',
  aiCorrectAnswer: '정답: {0}',
  aiPrev: '이전',
  aiNext: '다음',
  aiNewQuestions: '새 문제',
  aiEmptyTitle: 'AI로 문제를 생성해보세요',
  aiEmptyDesc: '파트와 난이도를 선택한 후 "문제 생성" 버튼을 눌러주세요.',
  aiLoadingMain: 'AI가 문제를 생성하고 검증하고 있습니다...',
  aiLoadingSub: '약 10~20초 소요됩니다',

  // Stats
  statsTitle: '토플 학습 통계 — Power TOEFL',
  statsDesc: '토플 문법 퀴즈 정답률, 오답노트 복습 현황 등 학습 통계를 한눈에.',
  statsH1: '📊 학습 통계',
  statsLoginPrompt: '로그인하시면 학습 통계를 확인할 수 있습니다.',
  statsTotalQuizzes: '총 퀴즈',
  statsTotalQuestions: '총 문항',
  statsAccuracy: '정답률',
  statsLast7Days: '최근 7일',
  statsWrongSummary: '오답노트 현황',
  statsViewAll: '오답노트 보기',
  statsTotalWrong: '총 오답',
  statsReviewed: '복습 완료',
  statsPending: '미복습',
  statsTopicAccuracy: '문법 주제별 정답률',
  statsAttempts: '{0}회 풀이',
  statsEmpty: '아직 학습 기록이 없습니다. 문법 퀴즈를 풀어보세요!',
  statsStartGrammar: '문법 학습 시작',

  // Pricing
  pricingTitle: '무료로 부족할 때 — Power TOEFL Pro 요금제 비교 (월 ₩19,900) | 2026',
  pricingDesc: '무료는 하루 10문항(비로그인 3문항)과 월 1회 풀모의. Pro는 무제한 풀이, 해설, AI 피드백, 광고 제거. 월 19,900원.',

  // Test
  testLCTitle: 'TOEFL Reading 모의고사 무료 — 학술 지문 독해 | 2026',
  testLCDesc: '2026 최신 TOEFL Reading 실전 모의고사 무료. 학술 지문 기반 50문항·30분. 오답노트 자동 저장.',
  testRCTitle: 'TOEFL Listening 모의고사 무료 — 대화·강의 청취 | 2026',
  testRCDesc: '2026 최신 TOEFL Listening 실전 모의고사 무료. 대화 + 강의 47문항·29분. AI 해설·오답노트 제공.',

  // Review (Ebbinghaus)
  reviewTitle: '오늘의 복습',
  reviewDesc: '에빙하우스 망각곡선 기반 스마트 복습 시스템',
  reviewSubtitle: '망각곡선에 따라 최적의 타이밍에 복습하세요',
  reviewRemaining: '남은 복습',
  reviewProgress: '복습 진행률',
  reviewCompleted: '🎉 오늘 복습 완료!',
  reviewCompletedDesc: '{0}개 문제를 복습했습니다',
  reviewEmpty: '오늘 복습할 문제가 없습니다',
  reviewEmptyDesc: '모든 복습을 완료했거나 아직 오답이 없습니다.',
  reviewStage: '{0}단계',
  reviewNextInterval: '{0}일 간격',
  reviewCorrect: '정답! 다음 단계로 이동합니다.',
  reviewWrong: '오답. 1단계부터 다시 시작합니다.',
  reviewNextReview: '다음 복습: {0}일 후',
  reviewResetMsg: '틀렸으므로 1일 후 다시 복습합니다.',
  reviewNext: '다음 문제',
  reviewFinish: '완료',
  reviewHowItWorks: '에빙하우스 복습 원리',
  reviewDaysLater: '{0}일 후',
  reviewExplanation: '틀린 문제는 1일 → 3일 → 7일 → 14일 → 30일 → 60일 간격으로 복습합니다. 정답 시 다음 단계로, 오답 시 1단계로 돌아갑니다.',

  // Notifications
  notifTitle: '알림',
  notifEmpty: '새 알림이 없습니다',
  notifMarkAllRead: '모두 읽음',
  timeJustNow: '방금',
  timeMinutes: '{0}분 전',
  timeHours: '{0}시간 전',
  timeDays: '{0}일 전',

  // Score card (canvas)
  scoreCardEstimated: '예상 점수',
  scoreCardCorrect: '정답',
  scoreCardIncorrect: '오답',
  scoreCardAccuracy: '정답률',

  // Push
  pushTitle: '학습 알림 받기',
  pushDesc: '복습 시간, 연속 학습 기록 등을 알려드립니다.',
  pushEnable: '알림 켜기',

  // Nav
  navReview: '복습',
  navStats: '통계',
  navPremium: '프리미엄',
  navSubscription: '구독 관리',
  roundDetailHeading: 'TOEFL 실전 모의고사',
  roundDetailOtherRounds: '다른 회차 보기',
  roundDetailBreadcrumbMockTest: '모의고사 목록',
  roundDetailLearningPoints: '이 회차 학습 포인트',
  roundDetailRelatedRounds: '비슷한 난이도 회차',
  roundDetailBackToHub: '← 전체 모의고사 목록',
  recTabTitle: '추천 회차',
  recBeginner: '입문 (섹션 15점 목표)',
  recIntermediate: '중급 (섹션 22점 목표)',
  recAdvanced: '고급 (섹션 28점 목표)',
  recScore300: '목표 총점 40~70',
  recScore500: '목표 총점 70~95',
  recScore700: '목표 총점 95~120',
  recFullMock: 'Reading + Listening 풀세트',
  recTrap: '함정 유형 특화',
  recWeakness: '약점 보완',
  recRecommended: '추천 회차 (최신)',
  recPointSuffix: '/30',
  recQuestionSuffix: '문항',
  recPartLabels: 'Reading,Conversations,Lectures',
  mockTestHubTitle: 'TOEFL 무료 모의고사 — 난이도별 회차 | Power TOEFL',
  mockTestHubDesc: 'TOEFL iBT 스킬을 난이도별 Power TOEFL 연습 회차로 훈련하세요. 회차별 문항 수와 구성은 운영 기준에 따라 제공되며 AI 해설을 제공합니다.',
  mockTestHubH1: '🎯 TOEFL 무료 모의고사 — 난이도별 회차',
  mockTestHubIntro: '입문·중급·고급 Power TOEFL 연습 회차를 제공합니다. 각 회차의 문항 수와 구성은 운영 기준에 맞춰 제공되며, 현재 공식 시험의 정확한 구성과는 다를 수 있습니다.',
  mockTestHubWhyTitle: '왜 Power TOEFL 난이도별 모의고사인가요?',
  mockTestHubWhy1: 'AI가 매주 새 문제를 생성 — 최신 TOEFL iBT 유형 반영',
  mockTestHubWhy2: '입문·중급·고급 3단계 난이도로 현재 수준에 맞는 회차 선택',
  mockTestHubWhy3: '회차별 고유 SEO 학습 가이드 — 구글·빙 크롤러가 읽을 수 있는 두꺼운 본문',
  mockTestHubWhy4: '오답노트 + 약점 분석으로 Reading·Listening 집중 보강',
  mockTestHubHowTitle: '어떻게 활용하나요?',
  mockTestHubHow1: '1️⃣ 목표 점수에 맞는 난이도 탭(입문/중급/고급)을 선택하세요',
  mockTestHubHow2: '2️⃣ 회차 상세 페이지에서 학습 포인트와 전략을 읽고 시험을 시작하세요',
  mockTestHubHow3: '3️⃣ 시험 후 AI 분석으로 약점 섹션을 확인하세요',
  mockTestHubHow4: '4️⃣ 같은 난이도의 다른 회차로 반복 연습하세요',
  mockTestHubFaq1Q: '모의고사 한 회차는 몇 문항인가요?',
  mockTestHubFaq1A: '회차마다 Reading·Listening 문항 수가 운영 기준에 따라 제공됩니다. 상세 페이지에서 해당 회차의 실제 문항 수를 확인할 수 있으며, Speaking·Writing은 별도 연습 페이지에서 제공합니다.',
  mockTestHubFaq2Q: '무료로 몇 회차까지 풀 수 있나요?',
  mockTestHubFaq2A: '모든 회차를 무료로 풀 수 있습니다. 하루 문제 풀이 수에 제한이 있으며, Pro 회원은 무제한입니다.',
  mockTestHubFaq3Q: '난이도는 어떻게 구분되나요?',
  mockTestHubFaq3A: '입문(섹션 15점 목표), 중급(22점), 고급(28점) 3단계로 구분됩니다. 각 회차 상세 페이지에 해당 난이도 맞춤 학습 가이드가 포함됩니다.',
  mockTestHubFaq4Q: '시험 결과는 어디서 확인하나요?',
  mockTestHubFaq4A: '시험 제출 후 결과 페이지에서 예상 점수와 섹션별 정답률을 확인할 수 있습니다. 로그인하면 기록이 저장됩니다.',
  mockTestHubAllRounds: '전체 회차 목록',
  mockTestHubEmpty: '현재 이용 가능한 회차를 준비 중입니다',
  mockTestHubEmptyDesc: 'AI가 매주 새 회차를 추가합니다. 그동안 섹션별 연습을 이용해 보세요.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 인기 TOEFL 모의고사',
  sectionSections: '섹션',
  roundDetailStrategyTitle: '이 회차에서 주의할 섹션별 전략',
  navSitemap: '사이트맵',
  navFaq: 'FAQ',
  roundSuffix: '회',

  // Footer extra
  footer7DayPlan: '7일 공부법',
  footerTrapPatterns: '함정 패턴',

  // PWA
  pwaAddToHome: '📱 홈 화면에 추가',
  pwaAddToHomeDesc: '앱처럼 바로 실행! 오프라인에서도 학습 가능',
  pwaInstall: '설치',
  pwaIOSGuide: '공유 → 홈 화면에 추가',

  // Grammar AI Quiz
  aiQuizTitle: '🤖 AI 맞춤 연습문제',
  aiQuizDesc: 'AI가 생성한 TOEFL 문법 문제',
  aiQuizGenerateDesc: '문법에 맞춘 TOEFL 스타일 문제 5개를 AI가 실시간으로 생성합니다.',
  aiQuizGenerate: 'AI 문제 생성하기',
  aiQuizGenerating: '🤖 AI가 문제를 생성하고 있습니다...',
  aiQuizGeneratingTime: '약 5~10초 소요됩니다',
  aiQuizNew: '새 문제',
  aiQuizStats: '누적 통계:',
  aiQuizTimes: '회',
  aiQuizCheckAnswers: '정답 확인하기',
  aiQuizPerfect: '🎉 전문 맞았어요!',
  aiQuizCorrectCount: '정답',
  aiQuizSaving: '결과 저장 중...',
  aiQuizTryNew: '새로운 문제 풀기',
  aiQuizError: 'AI 문제 생성에 실패했습니다. 다시 시도해 주세요.',

  // Tips shared
  tipsDetailStrategy: '상세 전략',
  tips7DayTitle: '🗓️ 시험 직전 7일 공부법',
  tips7DayDesc: '막판 루틴으로 점수를 극대화하세요',
  tipsTrapTitle: '⚠️ 함정 오답 패턴 총정리',
  tipsTrapDesc: '자주 낚이는 5대 패턴을 미리 파악하세요',

  // Pricing extra
  pricingSaveBadge: '30% 할인',
  pricingPerMonth: '월',
  pricingSSL: '보안 결제',
  pricingCard: '카드 결제',
  pricingPaymentSuccess: '프리미엄 가입 완료!',
  pricingPaymentCancelled: '결제가 취소되었습니다.',
  pricingLoginRequired: '로그인이 필요합니다.',
  pricingPaymentError: '결제 생성에 실패했습니다.',
  pricingCurrentPlan: '현재 플랜',
  pricingFaqQ1: '무료와 Pro의 차이는 무엇인가요?',
  pricingFaqA1: '비로그인은 하루 3문항, 로그인 무료는 하루 10문항과 월 1회 풀모의입니다. 해설·AI 피드백은 제한됩니다. Pro는 무제한 풀이, 상세 해설, Speaking·Writing AI 피드백, 광고 제거를 포함합니다.',
  pricingFaqQ2: '환불은 어떻게 처리되나요?',
  pricingFaqA2: '디지털 상품 특성상 원칙적으로 환불은 어렵습니다. 다만 관련 법령상 요구, 중복 결제, 서비스 미제공, 중대한 기술적 장애가 확인되는 경우 예외적으로 환불이 제공될 수 있습니다. 자세한 기준은 환불 및 해지 정책을 확인해 주세요.',
  pricingFaqQ3: '구독은 어떻게 취소하나요?',
  pricingFaqA3: '마이 구독 페이지에서 언제든 구독을 취소할 수 있습니다. 취소 후에도 남은 기간까지 이용 가능합니다.',
  pricingFaqQ4: '월간과 연간의 차이는?',
  pricingFaqA4: '기능은 같습니다. 연간(Ultra)은 월간 12개월 대비 약 17% 저렴합니다. 해지는 마이 구독에서 할 수 있습니다.',
  proBadgeLabel: 'Pro',

  // MySubscription extra
  subLoginRequired: '로그인이 필요합니다.',

  // Grammar page
  grammarSystematic: '체계적인 문법 학습',
  grammarBookTitle: 'TOEFL 영문법 Book',
  grammarBookDesc: '토플 시험에 필수적인 영문법 20가지를 체계적으로 학습하세요. 각 단원마다 실전 예문과 연습문제가 포함되어 있습니다.',
  grammarTestAfter: '문법 공부 후 바로 실전 테스트!',
  grammarTestAfterDesc: '배운 문법이 실제 토플에서 어떻게 출제되는지 확인하세요',
  grammarMockTest: '모의고사',
  grammarDoneTitle: '문법 학습을 마치셨나요?',
  grammarDoneDesc: '실전 모의고사에서 배운 내용을 바로 적용해 보세요. 틀린 문제는 오답노트에 자동 저장됩니다!',
  grammarStartRC: 'RC 실전 모의고사 시작',
  grammarPracticePart5: 'Reading 문법 연습',
  grammarCourseName: 'TOEFL 영문법 완벽 정리',
  grammarBreadcrumb: '영문법 Book',

  // Grammar Detail
  grammarHome: '홈',
  grammarExamples: '실전 예문',
  grammarTestKnowledge: '📝 실력 테스트',
  grammarTestKnowledgeDesc: '방금 배운 문법 관련 실전 문제를 풀어보세요!',
  grammarCheckAnswers: '정답 확인하기',
  grammarPerfect: '🎉 전문 맞았어요!',
  grammarCorrectCount: '정답',
  grammarMockCTA: '🔥 실전 모의고사로 실력을 검증하세요!',
  grammarMockCTADesc: 'RC 100문항 실전 모의고사 + 오답노트 자동 생성',
  grammarStartRCMock: 'RC 모의고사 시작',
  grammarPractice5: 'Reading 연습',
  grammarTestInPractice: '실전에서 확인하세요!',
  grammarTestInPracticeDesc: '문법 포인트가 실제 토플에서 어떻게 출제되는지 확인해 보세요.',
  grammarRelated: '📚 함께 보면 좋은 문법',

  // WrongAnswers
  wrongAnswersGrammarAI: '문법 AI',

  // StudyWidgets
  streakDays: '일',
  streakLabel: '연속 학습',
  streak7: '일주일 연속 학습 중!',
  streak14: '2주 연속 달성!',
  streak30: '대단해요! 한 달 연속!',
  reviewItems: '개',
  reviewTodayLabel: '오늘 복습할 문제',
  reviewGoLabel: '📚 복습하러 가기 →',

  // Leaderboard
  leaderboardTitle: '학습 랭킹',
  leaderboardWeekly: '주간',
  leaderboardMonthly: '월간',
  leaderboardLoading: '로딩 중...',
  loadingQuestions: '문제를 불러오는 중...',
  leaderboardEmpty: '아직 이번 {period} 데이터가 없습니다',
  leaderboardEmptyWeek: '주',
  leaderboardEmptyMonth: '달',
  leaderboardHint: '시험을 풀면 자동으로 랭킹에 등록됩니다!',
  leaderboardRank: '순위',
  leaderboardNickname: '닉네임',
  leaderboardSolved: '문제 수',
  leaderboardAccuracy: '정답률',
  leaderboardMe: '나',
  leaderboardMyRank: '🏅 내 순위: {rank}위',

  // TipsPartPage
  tipsCoreTips: '핵심 공략 팁',
  tipsStrategy: '실전 전략',
  tipsCTA: '전략을 익혔다면 실전으로!',

  // TestPage part labels
  testScrollHint: '스크롤하면 문제와 보기를 확인할 수 있습니다',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: '오디오를 듣고 정답을 선택하세요',
  testPart3Label: 'Lectures',

  // Credit purchase
  creditBuyBtn: '크레딧 구매',
  creditBuyTitle: 'AI 크레딧 구매',
  creditBuyDesc: 'Speaking/Writing AI 피드백 및 AI 연습에 사용할 추가 크레딧을 구매하세요.',
  creditBuyError: '결제 시작에 실패했습니다',
  creditBuyNote: 'PayPal 결제. 결제 완료 후 즉시 크레딧이 추가됩니다.',
  creditUnit: '크레딧',

  // Speaking page
  speakingPageH1: 'TOEFL Speaking 연습 2026',
  speakingPageSub: '{count}+ 무료 Speaking — Listen and Repeat · Interview · 모범답안',
  speakingPageTitle: 'TOEFL Speaking 연습 2026 — {count}+ 무료 프롬프트 & 모범답안 | Power TOEFL',
  speakingPageDesc: 'TOEFL Speaking 연습문제 {count}+개. 모범 답안, 채점 기준표, AI 피드백 포함. 2026 최신.',
  speakingAllTasks: '전체',
  speakingNoPrompts: '아직 Speaking 프롬프트가 없습니다',
  speakingNoPromptsSub: '프롬프트가 생성 중입니다. 곧 다시 확인해주세요!',
  speakingResponseTime: '응답 시간',

  // Writing page
  writingPageH1: 'TOEFL Writing 연습 2026',
  writingPageSub: '{count}+ 무료 Writing — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'TOEFL Writing 연습 2026 — {count}+ 무료 과제 | Power TOEFL',
  writingPageDesc: 'TOEFL Writing 연습 {count}+개. 모범 답안, 채점 기준표 포함. 2026 최신 업데이트.',
  writingAllTasks: '전체',
  writingNoPrompts: '아직 Writing 프롬프트가 없습니다',
  writingNoPromptsSub: '프롬프트가 생성 중입니다. 곧 다시 확인해주세요!',

  // CAT page
  catPageTitle: 'TOEFL Adaptive Test (CAT) — AI 난이도 자동 조절 | Power TOEFL',
  catPageDesc: 'TOEFL 컴퓨터 적응형 연습 시험. AI가 정답률에 따라 난이도를 자동 조절합니다.',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: '정답률에 따라 난이도가 자동 조절됩니다. 세션당 {count}문항.',
  catNote: "참고: 2026년 1월 이후 공식 TOEFL iBT의 Reading·Listening은 2단계 적응형입니다. 이 연습 CAT는 난이도만 조절하는 학습 도구이며, 공식 모듈 구조의 복제가 아닙니다.",
  catSelectSection: '섹션 선택',
  catStartBtn: 'Adaptive Test 시작',
  catLoading: '다음 문제 불러오는 중...',
  catNoMore: '더 이상 문제가 없습니다',
  catComplete: 'Adaptive Test 완료',
  catAccuracy: '정답률',
  catFinalLevel: '최종 난이도',
  catTryAgain: '다시 도전',
  catViewResults: '결과 보기',
  catNext: '다음',
  catExplanation: '해설',
  catStop: '정지',
  catPlayAudio: '🔊 오디오 재생',
  catReadingPassage: 'Reading Passage',

  // ScoreChart page
  scoreReadingHeader: 'Reading (0~30점)',
  scoreListeningHeader: 'Listening (0~30점)',
  scoreSpeakingHeader: 'Speaking (0~30점)',
  scoreWritingHeader: 'Writing (0~30점)',
  scoreSpeakingDesc: '4개 과제를 0~4점 척도로 채점 후 30점으로 환산',
  scoreWritingDesc: '2개 과제를 0~5점 척도로 채점 후 30점으로 환산',
  scoreSpeakingLevels: [
    ['4점 (Good)', '27~30점', '유창하고 정확한 답변, 논리적 전개'],
    ['3점 (Fair)', '19~26점', '대체로 명확하나 일부 오류'],
    ['2점 (Limited)', '11~18점', '기본 의사전달 가능하나 제한적'],
    ['1점 (Weak)', '1~10점', '의미 전달이 어려움'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5점 (Good)', '27~30점', '논리적이고 구체적인 에세이, 문법 정확'],
    ['4점 (Fair)', '22~26점', '전반적으로 좋으나 일부 미흡'],
    ['3점 (Limited)', '15~21점', '기본 구조는 있으나 전개 부족'],
    ['2점 (Weak)', '8~14점', '주제에서 벗어나거나 구조 불명확'],
    ['1점 (Very Weak)', '1~7점', '거의 의미 전달 불가'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    'Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+ 필요. 상위권 대학 입학 가능.',
    'Reading 22+ / Listening 22+ 목표. 대부분의 대학 입학 기준 충족.',
    '기본적인 학술 영어 수준. 조건부 입학 가능. 집중 학습 필요.',
    '기초 단계. Reading과 Listening 집중 학습 추천.',
  ],
};

export default ko;
export type Translations = typeof ko;
export type TranslationsBase = Omit<Translations, keyof import('./tierSeoI18n').TierSeoKeys | keyof import('./uiLocalePatch').UiPatchKeys>;
